import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzShowUploadList, NzUploadFile } from 'ng-zorro-antd/upload';
import { MinioControllerService } from 'src/app/sdk/services';
import { Lb4ApiService } from 'src/app/shared/service/api/lb4-api.service';

@Component({
  selector: 'app-upload-quotation',
  templateUrl: './upload-quotation.component.html',
  styleUrls: ['./upload-quotation.component.scss']
})
export class UploadQuotationComponent implements OnInit {
  @Input() formid: string;
  @Input() step: number;
  @Input() activeBtn: string;
  @Input() getProjectCategory: number;
  @Input() electromechanical: boolean = false;
  @Input() civilEngineering: boolean = false;
  @Input() uploadQuotationEditStatus: boolean = false;
  @Input() nzShowButtonOfUploadQuotation = false;//是否显示上传按钮
  @Input() nzShowUploadListOfUploadQuotation: NzShowUploadList;//是否显示删除
  @Output() quotationAmount = new EventEmitter<object>();
  @Output() quotationAttach = new EventEmitter<object>();


  quotationType = [];
  nzName = "file";
  fileList: NzUploadFile[] = [];
  quotationInfo = {
    civil: {
      quotedAmount: null,
      fileList: []
    },
    elec: {
      quotedAmount: null,
      fileList: []
    }
  };

  formQuotation = {};

  constructor(
    private lb4ApiService: Lb4ApiService,
    private minioControllerService: MinioControllerService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    // do something

  }
  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    this.quotationType = [];
    if (this.civilEngineering) {
      this.quotationType.push({ "text": this.translateService.instant('UploadQuotation.CivilEngineering'), "value": "civil" });
    }
    if (this.electromechanical) {
      this.quotationType.push({ "text": this.translateService.instant('UploadQuotation.MechatronicsEngineering'), "value": "elec" });
    }
    await this.getImagesOrFilesInit();
  }

  async isUpload(event: NzUploadFile[], civilOrelec: string) {
    this.quotationInfo[civilOrelec]['fileList'] = event;
    if (civilOrelec === "civil") {
      this.quotationAttach.emit({ "civilQuotAttach": event });
    }
    else {
      this.quotationAttach.emit({ "electroQuotAttach": event });
    }
  }

  ngQuotationInfoChange(event: number, civilOrelec: string) {
    this.quotationInfo[civilOrelec]['quotedAmount'] = event;
    if (civilOrelec === "civil") {
      this.formQuotation["civilQuotAmount"] = event;
    }
    else {
      this.formQuotation["electroQuotAmount"] = event;
    }
    this.quotationAmount.emit(this.formQuotation);
  }

  async getImagesOrFilesInit() {
    this.quotationInfo = {
      civil: {
        quotedAmount: null,
        fileList: []
      },
      elec: {
        quotedAmount: null,
        fileList: []
      }
    };
    await this.lb4ApiService.find('form_quotation', {
      order: 'id DESC',
      fields: { civilQuotAmount: true, electroQuotAmount: true, civilQuotAttach: true, electroQuotAttach: true },
      where: { formId: this.formid }
    }).then(async res => {
      if (res.length > 0) {
        let temp = JSON.parse(JSON.stringify(this.quotationInfo));
        if (this.civilEngineering) {
          temp['civil']['quotedAmount'] = res[0]['civilQuotAmount'];
          temp['civil']['fileList'] = res[0]['civilQuotAttach'].length > 0 ? JSON.parse(res[0]['civilQuotAttach']) : [];
        }
        if (this.electromechanical) {
          temp['elec']['quotedAmount'] = res[0]['electroQuotAmount'];
          temp['elec']['fileList'] = res[0]['electroQuotAttach'].length > 0 ? JSON.parse(res[0]['electroQuotAttach']) : [];
        }

        for (let type in temp) {
          if (temp[type]['fileList'].length > 0) {
            let fileOrImage = await this.minioControllerService.getQuotAttach({ url: temp[type]['fileList'][0] }).toPromise();
            let fileOrImageObject = JSON.parse(fileOrImage as any);
            let item: NzUploadFile[] = [
              {
                uid: 'name' + 0,
                name: temp[type]['fileList'][0].split('/')[2],
                status: 'done',
                url: fileOrImageObject['data'].replace('http://', 'https://'),
                thumbUrl: fileOrImageObject['data'].replace('http://', 'https://'),
              }
            ];
            temp[type]['fileList'] = item;
          }
        }
        this.quotationInfo = temp;
      }
    });
  }
}
